// eslint-disable-next-line import/prefer-default-export
import api from "@/api/api";

export const authActions = {
    async login(context, { email, password }) {
        try {
            await api.login(email, password).then(res => {
                context.commit('AUTHENTICATED', res.data);
                
                // Set the token
                api.setToken(`${res.data.token_type} ${res.data.access_token}`);

                // Store the expiry time (example, expires in 1 hour)
                const expiresAt = Date.now() + res.data.expires_in * 1000; // Assuming expires_in is in seconds
                localStorage.setItem('expires_at', expiresAt);

                // Fetch language and constants after login
                context.dispatch('getLangCode');
                context.dispatch('getConstants').then(() => location.assign('/'));
            });
        } catch (err) {
            if (err.response) {
                context.commit('SET_LOGIN_ERROR', err.response.data.errorCode);
            }
        }
    },

    logout(context) {
        // Clear token and expiry time on logout
        localStorage.removeItem('auth_token');
        localStorage.removeItem('expires_at');
        context.commit('LOGOUT');
        context.commit('CLEAR_PARC_DATES');
        // Optionally, redirect to the login page
        location.assign('/login');
    },

    checkToken(context) {
        const now = Date.now();
        const expiresAt = parseInt(localStorage.getItem('expires_at'));
        
        if (now > expiresAt) {
            context.dispatch('logout'); // Token expired, logout the user
        }
    }
};
